import React, { useState } from 'react'
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import { useNavigate } from 'react-router-dom';
import { utilities } from '../utilities/utilities';
import { leadGetApi ,leadCommonApi} from '../network/Services';
import Services from '../network/Services';
import konsole from '../network/konsole';
import LoaderScr from '../components/LoaderScr';

function UserInformation3() {
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false)
    const [userName, setUserName] = useState('')
    const [userEmail, setUserEmail] = useState('')
    const [userPhone, setUserPhone] = useState('')
    const [userPhoneError, setUserPhoneError] = useState("");

    const handleClick = (e) => {
        e.preventDefault();
        if (userPhoneError == undefined || userPhoneError == null || userPhoneError == "") {
            setIsLoading(true)
            let result = Services.getUserDetailsByEmailId(userEmail)
            result.then((res) => {
                setIsLoading(false)
                konsole.log("getUserDetailsByEmailId", res)
                let responseData = res?.data
                registrationInLeadStackers()
                if (responseData.length > 0) {
                   
                    navigateRoute(responseData[0]?.userId)
                } else {
                    setIsLoading(false)
                    createUserApi()
                    
                }
            }).catch((err) => {
                konsole.log("getUserDetailsByEmailId", err)
                setIsLoading(false)
            })
        }
    }


    const createUserApi = () => {
        let splitUserName = userName.split(' ')
        let firstName = splitUserName[0]
        let lastName = splitUserName?.slice(1).join(' ')
        let jsonobj = {
            "subtenantId": 3,
            "signUpPlateform": 12,
            "user": {
                "roleId": 19,
                "firstName": firstName,
                "lastName": (lastName) ? lastName : ".",
                "emailAddress": userEmail,
                "userName": userEmail,
                "countryCode": "+1",
                "mobileNumber": userPhone,
            }
        }
        konsole.log("jsonObject", JSON.stringify(jsonobj))
        setIsLoading(true)
        // let result = Services.createNewUser(jsonobj)
        let result = Services.createAcademyUser(jsonobj)
        result.then((res) => {
            setIsLoading(false)
            konsole.log("createNewUser", res)
            let responseData = res.data.data
            navigateRoute(responseData?.userId)
        }).catch((err) => {
            setIsLoading(false)
            konsole.log("createNewUser", err)
            if (err.response.data.data?.userId !== undefined && err.response.data.data?.userActivationMode === "ACTIVATE_USER") {
                navigateRoute(err.response.data.data.userId);
            }
        }).finally(() => {
            setIsLoading(false)
            konsole.log("createNewUser")
        })
    }

    //navigatewithprimaryuserId-------------------------------------------------------
    const navigateRoute = (userId) => {
        let jsonobj = { userEmail: userEmail, userMobile: userPhone, userName: userName }
        utilities.setSessionStoarge("userDetails", JSON.stringify(jsonobj));
        utilities.setSessionStoarge("primaryUserId", userId);
        utilities.setSessionStoarge("subtenantId", 3);

        navigate("legal");
    }
    const registrationInLeadStackers = async()=>{
        let tags = [`took legal readiness quiz`]
        let parts = userName.split(" ")
         let json2 ={
            "firstName":parts[0],
            "lastName":parts.slice(1).join(" "),
            "email":userEmail,
            "phone":userPhone

         }
        const result2 = await getLoggedInUserdata(userEmail,"POST",tags,json2);

    }
    const getLoggedInUserdata = async (email,method,tag,json2) => {
  
       
        let json = {
          email : email,
          tag : tag
     }
        const result = await leadGetApi(json,json2);
        if(result !== null && result !== undefined && result !== "" && !result?.tags.some((ele)=> ele === "took legal readiness quiz")){
          const result2 = await leadCommonApi(result,method,tag)
           return result2
        }
      if(result=='err') return;
      }


    const capitalization = (e) => {
        const capitalized = e.target.value.charAt(0).toUpperCase() + e.target.value.slice(1);
        console.log('capitalized', capitalized)
        setUserName(capitalized)

    }
    const mobileChange = (e) => {
        setUserPhone(utilities?.formatUsPhoneNumber(e.target.value))
        setUserPhoneError("")
    }
    const handelSend = (e) => {
        if (e.target.value.length < 14 && e.target.value.length > 0) {
            setUserPhoneError("Please enter a  valid cell number");
            return;
        }

    }

    return (
        <div className='FullHeight m-0 p-0 '>
            <LoaderScr isLoading={isLoading} />
            <div className="row rowHeight">
                <div className="col-6 m-0" style={{padding:"0px 50px"}}>
                {/* <a href="https://agingoptions.com" target="_blank"><img src="/logo.png" style={{width:"239px"}} className="m-3 mb-0"/></a>
                        <h3>Does Your Legal Plan for Retirement Truly Reflect Your Perspective?</h3>
                        <h4>Take the Legal Readiness Quiz and find out.</h4>
                        <p className="text-start">In just a few minutes, you’ll know if you’re at risk of being forced to live according to someone< br/> else’s ideas about how your life should be —and what<br/> action you should take next.</p>
                        <img src="/QuizHeader.png" style={{width:"505"}} className="m-3 mb-0"/>*/}
                            <div class="logo">
                                    {/* <img src="/logo.png" alt="AgingOptions Logo"/> */}
                            </div>
                            <div className="Content_height row ">
                                <div className="col-12 p-0">
                                    <h1 class="main-heading ">Does Your Legal Plan for Retirement Truly Reflect Your Perspective?</h1>
                                    <h4 className="belowText">Take the Legal Readiness Quiz and find out.</h4>
                                    <p class="subtext mb-0">
                                    In just a few minutes, you'll know if you're at risk of 
                                    being forced to live according to someone else's ideas about your future—and what steps to take next.
                                    </p>
                                </div>
                                <div className="col-12 p-0">
                                    <img class="hero-image p-0" src="/QuizHeader.png" alt="Designing Your Ideal Future"/>
                                </div>
                            </div>
                        </div> 


                <div className="col-6 p-0 d-flex justify-content-center align-items-center" style={{background:"#dcdcdc7d",borderRadius:"14px"}}>
                    <Form className='' onSubmit={handleClick} className=' LegalLoginForm ' >
                        <div>
                            <Form.Group className="mb-3" controlId="formBasicName">
                                <Form.Label>Name</Form.Label>
                                <Form.Control type="text" placeholder="Name" required onChange={(e) => capitalization(e)} style={{ textTransform: "capitalize" }} />
                            </Form.Group>
                            <Form.Group className="mb-3" controlId="formBasicEmail" >
                                <Form.Label>Email</Form.Label>
                                <Form.Control type="email" placeholder="Email" required onChange={(e) => setUserEmail(e.target.value)} />
                            </Form.Group>
                            <Form.Group className="mb-3" controlId="formBasicEmail">
                                <Form.Label>Phone</Form.Label>
                                <Form.Control type="text" placeholder="Phone" value={userPhone} onChange={(e) => mobileChange(e)} onBlur={(e) => handelSend(e)} />
                                <p className='text-danger mb-0'>{userPhoneError && <div className="mb-0">{userPhoneError}
                                </div>}</p>
                            </Form.Group>
                            <Button variant="primary" type="submit">Next</Button>
                        </div>
                       
                    </Form>
                </div>
            </div>
            {/* <div className="footerDesign">
                <footer className='text-center'>© Copyright AgingOptions. All Rights Reserved</footer>
            </div>  */}
        </div>
    )

}

export default UserInformation3